import Skeleton from "@mui/material/Skeleton"

export default function SkeletonStack({
  length,
  variant = "rectangular",
  width,
  height,
}) {
  return new Array(length)
    .fill(null)
    .map((_, i) => (
      <Skeleton key={i} variant={variant} width={width} height={height} />
    ))
}
